<template>
  <div class="wrap">
    <h1>高德黑卡商家服务协议</h1>
    <section>
      <p style="text-align: left; margin: 10px 0">
        本版更新日期：2021年5月26日
      </p>
      <p>&nbsp;</p>
      <p style="margin-bottom: 10px">
        【签约主体】本协议是购买高德黑卡服务（以下简称&ldquo;黑卡服务&rdquo;）的主体（以下简称&ldquo;商户&rdquo;或&ldquo;甲方&rdquo;）与高德集团（以下简称&ldquo;高德&rdquo;或乙方）就其成为高德黑卡商家事宜所签署的协议。
      </p>
      <p>&nbsp;</p>
      <p style="margin-bottom: 10px">
        <strong
          >【审慎阅读】商户在签署本协议或使用黑卡服务之前，应审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款。免除或者限制责任的条款可能以加粗字体显示，商户应重点阅读。</strong
        >
      </p>
      <p>&nbsp;</p>
      <p style="margin-bottom: 10px">
        【签约动作】商户通过高德黑卡商家后台注册/登录账户并在相应页面点击确认本协议，则表示商户愿意接受本协议约束，本协议将正式生效并对商户与高德产生法律约束力。如商户不同意本协议任何内容，或无法清楚理解本协议某个条款含义的，请勿进行后续操作。
      </p>
    </section>

    <h2>第一条 相关定义与协议范围</h2>
    <section>
      <p style="margin: 10px 0">
        1、高德黑卡商家平台：是指乙方委托其服务商即深圳市德友惠信息技术有限公司所开发并提供平台代运营服务，能够为高德黑卡商户提供商品、门店信息编辑等信息技术服务及相应软件技术服务的平台，包括但不限于网页以及相应的客户端软件（如德友惠APP）等，以下简称商家平台。
      </p>

      <p style="margin-bottom: 10px">
        2、黑卡商家展示平台：是指通过相应的技术能力满足用户可以对黑卡商家所发布的商品进行信息浏览、完成订单生成并下单支付的信息服务平台，本协议项下特指高德地图APP的相关页面，以下简称展示平台。
      </p>

      <p style="margin-bottom: 10px">
        3、商户：指入驻商家后台并开通高德黑卡服务开展经营活动的各种经营主体。
      </p>

      <p style="margin-bottom: 10px">
        4、用户：指通过高德地图使用或购买商户所提供的商品或服务的消费者。
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 10px">
        <strong>5</strong
        ><strong
          >、本协议包括协议正文及所有高德已发布或将来发布并依法通知商户的各类规则。所有高德公布的规则均为本协议不可分割的一部分，与本协议正文具有同等法律效力。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        <strong>6</strong
        ><strong
          >、为不断提升消费者及商户体验、适应法律法规要求等原因，高德可根据需要修改本协议，对于影响商户权利义务的变更高德将提前至少</strong
        ><strong>7</strong
        ><strong
          >天在商家平台公示。对本协议的修订一经公示生效即构成对协议方权利义务的补充，成为本协议的一部分。如您不同意相关变更，须通知高德，高德可选择终止相关变更或任一方可在变更生效前选择解约（商户可选择主动退出合作）。如您在相关变更生效后仍登录或继续使用黑卡服务将表示您接受修订后的协议。除另行声明或签署协议外，高德任何基于提升消费者及商户体验、平台服务升级等目的所扩大的服务范围或软件功能的增强均受本协议的约束。</strong
        >
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 10px">
        <strong>7</strong
        ><strong
          >、本协议一经您或您授权的任何人点击确认或由您与高德另行书面签署即于您和高德之间发生法律约束力。对于本协议生效前已经开通黑卡服务的商户，本协议构成协议方之间就使用黑卡服务所达成协议的修订和补充，本协议可在商家平台查询。</strong
        >
      </p>
    </section>

    <h2>第二条 黑卡服务</h2>
    <section>
      <p style="margin: 10px 0 8px 0">
        1、高德向商户提供的黑卡服务包括&ldquo;标准服务&rdquo;&ldquo;增值服务&rdquo;两类套餐，各类套餐内容解释具体参照附件一《服务项目表》。
      </p>

      <p style="margin-bottom: 8px">
        1）&ldquo;标准服务&rdquo;套餐内容包括：专属流量优先、专属黑卡标记、发布商品、全品类支持、定制活动、24小时内客服反馈等子项目；
      </p>

      <p style="margin-bottom: 10px">
        2）&ldquo;增值服务&rdquo;服务包含：雷达展示、闲时提醒等，该服务与基础服务组合提供不单独输出。
      </p>

      <p style="margin-bottom: 10px">
        2、商户自主选择购买其意向的套餐服务，高德将根据商户所选择的套餐向商户收取相应服务费用，如收取费用后在当地没有展开业务推广，乙方全额退还想用服务费用。
      </p>

      <p style="margin-bottom: 10px">
        3、服务生效：商家应按照乙方操作指引将其经营资质上传至在商家平台并通过商家平台审核以及完成黑卡服务所需费用支付后方可正式获得&ldquo;黑卡&rdquo;商家资格并使用其所选购的黑卡服务。
      </p>

      <p style="margin-bottom: 10px">
        4、商家有权依照其所购买的服务享受该服务并有权了解其经营行为产生的收益。
      </p>

      <p style="margin-bottom: 10px">
        <strong>5</strong
        ><strong
          >、
          为了改善用户体验、完善服务内容等高德可能会不定期进行更新、修改，包括开发新功能</strong
        ><strong>/</strong><strong>权益、删除旧功能</strong><strong>/</strong
        ><strong
          >权益等，并可能根据新的服务内容调整收费标准。若乙方进行相应调整时，将提前通过平台通知、邮件等书面方式进行通知，乙方可自主选择接受变更后的相应权益、功能、服务和费用调整继续使用，亦可拒绝相关调整并终止双方合作。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        6、乙方在使用黑卡服务或在商家平台进行相应操作时应遵循商家平台的相关规则，如部分黑卡服务可能依赖于支付宝公司提供的当面付服务等，如您涉及使用该部分产品服务的，需另行与支付宝公司签署相关协议，具体以系统提示为准<strong
          >。</strong
        >
      </p>
    </section>

    <h2>第三条 费用支付及发票开具</h2>
    <section>
      <p style="margin: 10px 0">
        1、本协议约定的甲方应向乙方支付的各项服务费用，甲方应按照确认具体服务或产品时确认的收费方式和收款账号予以支付。对于您应支付的黑卡商家套餐服务费由您付至我方黑卡商家平台服务商德友惠指定账户，并由德友惠统一支付至高德。
      </p>

      <p style="margin-bottom: 10px">
        2、本协议约定的甲方应向乙方支付的各项服务费用，乙方实际收取后，按照税务法律法规及相关政策规定向甲方开具相应金额的增值税发票，具体发票开具办法以乙方另行公示的内容为准。
      </p>
    </section>

    <h2>第四条 甲方承诺与保证</h2>
    <section>
      <p style="margin: 10px 0">
        <strong>1</strong
        ><strong
          >、甲方保证其为一家合法成立并有效存续的经营主体，能够独立承担法律责任，并具有履行本协议所需的一切权利及能力；同时甲方应当按乙方要求提供有效的身份证明资料及经营能力证明文件，包括但不限于营业执照、许可证及其他相关法律法规规定应当具备的许可或备案文件。甲方应始终具备上述条件，保证不提供任何虚假、失效文件或以任何第三方的资料申请入驻商家平台，同时有义务在相关资料实际变更时及时通知乙方并更新有关资料，如乙方有合理怀疑且甲方无法提供充分的证据证明其未违反上述条件任何一项的，乙方有权随时下架甲方全部或部分在售商品，并中止或终止本协议，甲方须承担由此产生的全部法律责任。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        <strong>2</strong
        ><strong
          >、甲方保证通过商家平台发布服务或商品信息，符合国家法律、法规、规章的规定，涉及行政许可的，已依法取得相应的许可。同时甲方保证通过商家平台发布有关商品或服务信息，不侵犯任何第三方合法权益，包括但不限于知识产权、物权、肖像权等合法权利。如甲方发布含有任何违反法律、法规、商家平台相关规则或制度的信息或链接的，乙方有权在展示平台对相关信息或链接进行屏蔽或删除。</strong
        >
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 10px">
        <strong>3</strong
        ><strong
          >、对于甲方提供的商品或服务信息以及经营资质，乙方委托其商家平台的服务商对前述信息与资质进行审核，但前述审核不应视为乙方对甲方和</strong
        ><strong>/</strong
        ><strong
          >或用户行为的合法性、有效性、以及甲方服务或商品的真实性、合法性和有效性作了任何明示或暗示的担保，甲方仍对其发布的商品和服务信息及其销售行为承担完全独立的责任。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        4、甲方作为商品或服务的实际销售者，应履行销售者责任，向用户提供相应的售后服务，并负责向用户开具商品或服务的发票，同时还应按照实际交易额依法向主管税务机关申报纳税。
      </p>

      <p style="margin-bottom: 10px">
        5、甲方应遵守诚实信用原则，确保甲方所发布的服务或商品信息真实、准确、合法、有效且与甲方实体门店实际提供的服务或销售的商品相符，不得恶意加价（包括但不限于同一商品或套餐其销售价格高于该商品或套餐在其他平台上销售价格）并在交易过程中切实履行甲方对外公示的交易承诺。
      </p>

      <p style="margin-bottom: 10px">
        6、甲方应维护商家平台市场良性竞争秩序，不得贬低、诋毁竞争对手，不得干扰商家平台上进行的任何交易、活动，不得以任何不正当方式提升或试图提升自身的信用度，不得以任何方式干扰或试图干扰商家平台的正常运作。
      </p>

      <p style="margin-bottom: 10px">
        7、甲方不得向乙方或乙方关联公司的员工、顾问提供任何形式的不正当利益，不得贿赂或以其他不正当方式收买、企图收买乙方或乙方关联企业之员工、顾问为甲方提供不正当利益。
      </p>

      <p style="margin-bottom: 10px">
        <strong>8</strong
        ><strong
          >、如甲方需要变更其在商家平台收款支付宝账户其应取得乙方同意后方可变更，甲方变更支付宝收款账号后若其变更前的支付宝账号仍有未核销订单，甲方不得以变更为由拒绝履行此订单的核销或退款义务。收款支付宝账户新增、变更、删除等操作产生的全部风险与责任由甲方自行承担。同时，甲方承诺其已获得了甲方设定的收款支付宝账户的账户持有人同意，即同意当甲方违反本协议约定时，乙方可按本协议约定从甲方及其甲方设定的甲方门店收款支付宝账户中扣取相应款项作为对乙方或第三方的赔偿。</strong
        >
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 10px">
        9、为了保证交易安全，甲方同意通过商家平台进行的交易使用支付宝公司提供的支付方式或商家平台支持的其他支付方式，为此甲方须承担用户支付过程中可能产生的通道手续费，同时商户授权高德向支付宝公司发出指令关闭其收款支付宝账户的&ldquo;余额支付&rdquo;功能。
      </p>

      <p style="margin-bottom: 10px">
        <strong>10</strong
        ><strong
          >、商户承诺不会采取任何手段或措施如明示或暗示用户或以其他方式转移其可通过商家平台达成的交易，或达成交易后不经由商家平台支持的收费方式收取交易金额，以规避向高德支付相关费用。如商户违反前述承诺，商户同意高德可终止本协议。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        11、甲方应妥善保管签约本协议的账号和密码，经由签约账号进行或授权的行为将视为商户本身的行为，由商户承担相应的法律责任。
      </p>

      <p style="margin-bottom: 10px">
        12、甲方不得采取任何技术手段，对商家平台或展示平台进行反编译、破解或采取任何其他技术手段进行干扰、破坏，损害乙方或其他任何第三方的合法权益。
      </p>

      <p style="margin-bottom: 10px">
        <strong>13</strong
        ><strong
          >、商户须严格遵守网络安全与数据保护相关法律的要求，在店铺经营过程中收集、使用及共享的信息中涉及用户个人信息的，须遵循合法、正当、必要原则，不得违反相关法律的规定及商户与用户之间的约定，包括：在无用户其他授权的情况下，商户应将用户的订单信息等与交易有关的必要信息仅用于《高德隐私权政策》中约定的为满足用户购买商品或服务、完成售后服务的目的；禁止未经用户明确同意或超出用户授权范围使用其信息或非法向他人提供用户个人信息等。商户应当采取必要的技术措施保障数据安全，在发生或可能发生信息安全风险时，应当立即采取补救措施，按照规定及时告知用户并向有关主管部门报告。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        <strong>14</strong
        ><strong
          >、甲乙双方同意合作期间对相关商品或服务开展不定期的运营活动，在活动中，任何一方及员工不得以任何形式自行或者协助他人套取活动资源、参与作弊、开展虚假交易等，否则守约方有权要求违约方返还已经套取的活动资源或向守约方赔偿同等价值的款项。同时，活动一旦发现有套现、作弊、虚假交易、洗钱等风险的，守约方有权立即停止活动和资源投入，要求违约方限期支付守约方承担的所有活动成本及守约方的损失（包括但不限于为用户承担的活动优惠、运营成本等）；如违约方是甲方，且甲方未按照乙方要求限期支付上述费用的，乙方有权委托支付宝公司从甲方支付宝账户及甲方设定的收款支付宝账户中直接扣取相应费用。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        15、甲方应在活动结束后6个月内保留具体运营活动的资料，包括但不限于活动海报、网站/APP活动截图、现场照片/视频等，且资料内容应当清晰可供辨识，如：提供现场照片的，照片应能够清晰显示活动规则文案。甲方应根据乙方需要随时配合提供上述资料。
      </p>

      <p style="margin-bottom: 8px">
        16、甲方对在甲方门店或甲方管理范围内开展的活动具有安保义务，具体如下：
      </p>

      <p style="margin-bottom: 8px">
        （1）甲方负责活动现场秩序维护及安全管理，保证用户的人身和财产安全。如用户在活动现场遭受人身、财产损害，由甲方负责赔偿和解决。由此给乙方及关联公司造成损失（包括但不限于向第三方赔偿、遭受行政处罚等），甲方应向乙方及关联公司足额赔偿。
      </p>

      <p style="margin-bottom: 8px">
        （2）活动开始前，甲方应负责对设备、设施（包括但不限于电梯、步行梯、通风、消防、店内广播等）进行系统检查，确保设施设备运行正常、消除各类安全隐患。
      </p>

      <p style="margin-bottom: 8px">
        （3）活动期间，甲方应安排人员巡视人流情况，根据人流的实际情况进行疏导和控制，若活动现场内人员密集，应在出入口采取限流放行等措施。
      </p>

      <p style="margin-bottom: 10px">
        （4）甲方应对活动期间可能出现的突发紧急情况制定相合理有效的应急方案，包括但不限于活动现场出现的违法行为（非法集会、示威、自伤、自残等）、停电、拥堵、踩踏、打砸抢等事件。
      </p>

      <p style="margin-bottom: 10px">
        17、甲方保证其已获得必要的授权，有权代表已经/将要开设在其名下的所有门店签署本协议，甲方签署本协议即代表甲方名下门店均签署本协议并同意入驻商家平台。甲方门店行为均视为甲方行为，如甲方门店违反本协议约定或违反商家平台规则或存在损害用户权益之行为的，甲方应督促其进行改正，经乙方纠正后甲方或/甲方门店拒绝纠正或纠正后仍不符合本协议约定的，乙方有权依照本协议或平台规则等对违约的甲方门店或甲方进行处罚或者停止合作，甲方及甲方门店共同承担连带责任。甲方应妥善处理其与甲方门店的合作关系及（或）可能发生的纠纷/争议，并可使乙方完全免责。
      </p>
    </section>

    <h2>第五条 乙方承诺与保证</h2>
    <section>
      <p style="margin: 10px 0">
        1、根据法律法规之规定，乙方或乙方服务商须对甲方提交的各种资料和上传的信息进行审核和登记，若乙方或乙方服务商发现甲方上传的资料或信息存在虚假、错误或其他问题时，乙方或乙方服务商有权要求甲方予以补正，若甲方未予以补正的，乙方或乙方服务商有权拒绝甲方的相关服务要求，并有权对甲方采取必要措施（包括但不限于屏蔽、下线、删除甲方商品或服务等）。
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 10px">
        <strong>2</strong
        ><strong
          >、乙方有权对甲方使用商家平台各项服务的情况进行监督和检查，若乙方发现甲方在使用高德提供的相关服务过程中，存在违法违规或其他损害他人合法利益的行为的，乙方有权对甲方采取必要措施，以制止相应的违法行为，因此产生的任何损失，由甲方自行承担。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        3、乙方可能会其对提供的各项服务进行升级、改造和更新，乙方在进行相应升级、改造或更新时，将采取合理方式通知甲方，以减少对甲方的影响。甲方理解并同意，根据国家相关法律法规规定、行业风险评估、具体业务开展情况等考虑，高德可能会对部分行业的相关服务进行调整，包括停止部分服务的提供、取消某些服务的功能等，具体以商家平台实际提供的服务为准。
      </p>

      <p style="margin-bottom: 10px">
        4、乙方可能会开展相关运营活动，甲方可选择是否参与相应的运营活动，如甲方自愿选择参加相应的运营活动，应遵守相应的运营活动规则，不得擅自退出活动，不得随意取消相应的优惠，否则因此产生的法律责任由甲方承担。同时甲方授权乙方可以在不改变商户实收金额的情况下，将甲方发布的符合活动条件的商品或服务纳入平台活动中。为推广商户店铺或其商品，高德可在商户参加高德官方举办的市场活动期间（包括&ldquo;双十一&rdquo;、&ldquo;出行节&rdquo;等）对外公示商户店铺的活动总交易额、某类目或某单品的交易额，亦可将上述信息作宣传推广使用。
      </p>

      <p style="margin-bottom: 10px">
        5、乙方有权对用户投诉进行处理，若用户就使用甲方商品或服务发生任何纠纷向乙方进行投诉的，乙方有权按照商家平台的相关售后服务规则进行处理。
      </p>

      <p style="margin-bottom: 10px">
        <strong>6</strong
        ><strong
          >、乙方有权根据乙方拥有的信息，判断甲方提交的店铺信息的准确性、真实性与完整性。如果基于对甲方的店铺信息以及乙方拥有的其他信息的综合分析，乙方合理判断出甲方的店铺信息虚假、已经关闭或停止营业，则乙方有权在地图中全部或部分删除甲方的店铺信息，并且无需因此向甲方承担责任。如果甲方的店铺仍在运营，甲方可以联系乙方反馈相关信息，以便于乙方审核以判断是否标注。</strong
        >
      </p>

      <p style="margin-bottom: 10px">
        7、乙方有权对乙方提供的各项服务的收费政策和功能以及平台规则、管理制度等进行调整，若乙方进行相应调整时，将提前通过本协议约定的方式进行通知，若甲方继续使用相应服务或功能，则相应调整将对甲方生效。
      </p>

      <p style="margin-bottom: 8px">8、信息使用及处理</p>

      <p style="margin-bottom: 8px">
        1)
        乙方有权收集、存储和使用甲方的信息，包括但不限于甲方提供的、甲方授权的、甲方在商家平台上产生的、乙方获取的以及来自第三方的信息。乙方可在合理范围内使用或整合甲方的包括但不限于注册信息、交易信息、设备信息、有关网络日志以及自乙方的关联公司、合作伙伴取得甲方已授权或依据法律法规可共享的信息。
      </p>

      <p style="margin-bottom: 8px">
        2）为了给甲方提供更多经营数据的参考，乙方可能会将甲方经营情况与其他商户的经营情况进行比较分析，并将分析结果（包括但不限于某一区域内优惠核销率等）提供给甲方进行参考。同时，也可能在不向其他商户透露甲方具体身份信息的情况下，将分析结果提供给其他商户。但甲方理解并同意，乙方输出的分析结果仅供甲方参考，如甲方使用分析结果而产的任何损失与乙方无关。
      </p>

      <p style="margin-bottom: 8px">
        3）除非事先获得甲方的授权或本协议另有规定外，乙方不会将这些信息对外公开或向第三方提供（乙方平台关联公司除外）。但以下情况除外：
      </p>

      <ol style="margin-bottom: 8px; list-style: none; padding-left: 10px">
        <li>a) 为甲方提供商品和服务所必要公布的信息。</li>
      </ol>

      <ol style="margin-bottom: 8px; list-style: none; padding-left: 10px">
        <li>
          b)
          依据法律、法规、政府机关及监管部门核查的强制要求、按照法庭传票、法律命令或遵循法律程序而需提供，具体核查要求的信息以政府监管部门的要求为准。
        </li>
      </ol>

      <ol style="margin-bottom: 8px; list-style: none; padding-left: 10px">
        <li>c) 乙方以学术研究、调研或公共利益为目的。</li>
      </ol>

      <ol style="margin-bottom: 8px; list-style: none; padding-left: 10px">
        <li>d) 为维护商家平台及其关联公司、用户及其他商户的合法权益。</li>
      </ol>

      <p style="margin-bottom: 8px; padding-left: 10px">
        e) 依据相关服务条款或使用协议的规定而提供。
      </p>
    </section>

    <h2>第六条 保密条款及知识产权</h2>
    <section>
      <p style="margin: 10px 0">
        1、【保密条款】除经对方事先书面许可或本协议另有约定外，本协议任何一方均不得泄露本协议任何内容及协议签订/履行情况，应将获得的对方之包括但不限于业务、经营、财务状况和其他保密信息予以严格保密，不得以任何形式向任何第三方披露。否则，因此给守约方造成任何损失的，违约方应承担因此给守约方造成的全部损失。保密义务在协议有效期间及终止后始终有效，不因本协议其他条款整体或部分无效、被撤销而失效。
      </p>

      <p style="margin-bottom: 10px">
        2、【知识产权】甲方理解并同意，除非乙方另行声明，商家平台内的软件、服务和内容（包括但不限于软件、技术、程序、数据、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等，以下简称&ldquo;全部资料&rdquo;）的所有知识产权（包括但不限于著作权、商标权、专利权、商业秘密等）及相关权利，均归属于乙方及（或）乙方关联公司所有。未经乙方/乙方关联公司许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛、爬虫等程序或设备监视、复制、传播、展示、镜像、上载、下载商家平台内的软件、服务和内容）。未经乙方及（或）乙方关联公司书面授权甲方不得以任何方式展示、使用或作其他处理，也不得向他人表明其有权展示、使用、或作其他处理。
      </p>

      <p style="margin-bottom: 10px">
        3、甲方保证，其在商家平台上传、发布的文字、图片、视频、音频、软件以及表演等为甲方原创或已获合法授权；并同意将前述文字、图片、视频、音频、软件以及表演等无偿授权乙方包括但不限于存储、使用、发布、复制、出租、展览、展示、放映、广播、信息网络传播、摄制、修改、改编、汇编、出版、翻译、据以创作衍生作品、传播、表演等权利。对于与著作权相关的任何及一切人身权利，甲方在此明确承诺将不予主张或放弃，或者在法律允许的最大范围内，一并授权给乙方使用。
      </p>

      <p style="margin-bottom: 10px">
        4、双方合作期间，基于本协议目的，甲乙双方可以合理地使用对方的相应知识产权，包括但不限于商标、标识、产品或服务名称、LOGO等知识产权；但未经一方授权，另一方不得将一方的知识产权用于本协议目的之外的场合。
      </p>
    </section>

    <h2>第七条 违约责任</h2>
    <section>
      <p style="margin: 10px 0">
        <strong>1</strong
        ><strong
          >、甲方违反本协议相关约定的，包括但不限于未按规定提供相应资质、发布的信息违法违规侵犯他人合法权益、未遵守相应的规则或承诺、违反约定导致用户纠纷或投诉等，高德有权要求商户在合理期限内纠正相应违约行为并积极采取补救措施，若商户未在改正期内纠正其违约行为或积极采取补救措施的，高德有权对商户采取限制部分功能、下架商品或服务、屏蔽店铺、冻结交易、冻结账户等措施，同时有权解除本协议并要求商户赔偿乙方因此遭受的损失，包括但不限于高德支付的律师费、消除影响所支付的必要费用、商业损失、合理预期利益损失及其他因商户违约所遭受的损失。</strong
        >
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 10px">
        <strong>2</strong
        ><strong
          >、因乙方未能按照协议约定履行义务，且在甲方要求的期限内拒绝纠正或纠正后仍不符合本协议约定的，应承担因此给甲方造成的实际损失。</strong
        >
      </p>
    </section>

    <h2>第八条 免责及有限责任</h2>
    <section>
      <p style="margin: 10px 0 8px 0">
        <strong>1</strong
        ><strong
          >、乙方将按现有技术提供黑卡服务，但以下情况下乙方不需要承担责任：</strong
        >
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 8px">
        <strong>（</strong><strong>1</strong
        ><strong>）商家平台系统停机维护；</strong>
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 10px">
        <strong>（</strong><strong>2</strong
        ><strong
          >）因通信公司有线或无线通信系统、设备的检修、维护或不稳定，或黑客攻击，或电力部门技术调整或故障，或支付机构的问题等原因，或由于不可抗力事件导致乙方服务中断或不稳定，不视为乙方违约。</strong
        >
      </p>
      <p><strong> </strong></p>
      <p style="margin-bottom: 10px">
        <strong>2</strong
        ><strong
          >、乙方不对甲方商品或服务的真实性、合法性和有效性作任何明示或暗示的担保，也不承担任何责任。</strong
        >
      </p>
    </section>

    <h2>第九条 协议终止</h2>
    <section>
      <p style="margin: 10px 0">
        1、本协议期限届满后或符合本协议约定的其他终止条件时，本协议终止。本协议经双方协商一致可提前解除。
      </p>

      <p style="margin-bottom: 8px">
        2、本协议终止后，双方同意按照如下约定履行相关善后义务：
      </p>

      <p style="margin-bottom: 8px">
        （1）乙方有权删除平台上已发布的甲方信息，且有权拒绝向甲方提供相关信息；
      </p>

      <p style="margin-bottom: 8px">
        （2）本协议终止前甲方已与用户达成的尚未履行完毕的订单，甲方应按照本协议及订单的约定继续履行相应义务；
      </p>

      <p style="margin-bottom: 8px">
        （3）如乙方已经按照协议规定提供相关服务，甲方应按本协议规定的服务费就已经提供的服务向乙方支付费用；
      </p>

      <p style="margin-bottom: 8px">
        （4）按照相关法律法规，甲方理解并同意乙方保存甲方资质信息、商品信息、交易记录等相关资料。
      </p>

      <p style="margin-bottom: 10px">
        （5）甲方同意在本协议终止后，如甲方仍存在未解决的纠纷，乙方有权通知支付宝公司将甲方的支付宝账户余额或双方协商一致的一定金额进行冻结，用于解决服务协议终止后的履约纠纷或对消费者投诉进行赔付；待纠纷解决后，乙方通知支付宝公司将冻结款项解冻。
      </p>
    </section>

    <h2>第十条 其他约定</h2>
    <section>
      <p style="margin: 10px 0">
        1、本协议的执行、解释及争议的解决均适用中华人民共和国法律，且不考虑任何冲突法。您和高德就本服务的使用、本协议内容或其执行发生任何争议的，双方应友好协商解决；如双方无法协商解决争议时，双方同意应将争议提交至北京市朝阳区人民法院裁决。
      </p>

      <p style="margin-bottom: 10px">
        2、本协议自甲方首次通过在乙方或乙方关联公司平台点击确认之日起生效，有效期一年。本协议到期前和后续历次有效期届满前，除非甲乙双方任意一方以本协议约定的通知方式告知对方不再续签，否则本协议将自动续签一年，续签次数不限。
      </p>

      <p style="margin-bottom: 10px">
        3、如无其他约定，您与高德及其关联公司之间所签署协议中提及的《高德商户服务协议》即指本协议。
      </p>

      <p style="margin-bottom: 10px">
        4、乙方有权根据业务调整的需要，终止履行本项协议，在不影响甲方利益的前提下，乙方应安排具备履约能力的第三方继续履行本项协议下的权利义务，乙方应事先通过本协议约定的方式通知甲方。
      </p>

      <p style="margin-bottom: 10px">
        5、本协议所称的“通知”，包括纸质盖章文件形式，或通过甲方在乙方或乙方关联公司平台上预留的邮箱（或通过本协议约定的指定邮箱）发送邮件，或通过甲方在签约过程中在乙方或乙方关联公司平台上预留的手机号码发送短信，或通过网站、APP页面公告、站内信/弹窗等方式。该等通知于发送之日即视为已送达收件人。
      </p>
    </section>
    <h2>附件</h2>
    <section>
      <p style="margin-bottom: 10px"></p>
      <p style="margin-bottom: 10px">
        附件一：《高德地图黑卡商家服务项目表》（主协议中简称：《服务项目表》）
      </p>
      <p style="margin-bottom: 20px">
        本附件《高德地图黑卡商家服务项目表》为《高德地图黑卡商家服务协议》中第二条服务项目的具体内容解释，并包含选择购买部分服务项目时乙方将会随之增加的权利义务。因此乙方务必谨慎阅读相关条款，乙方最终的选择视为其审慎阅读相关条款后作出的真实意思表达。
      </p>

      <div style="margin-bottom: 10px">
        <div
          style="
            display: flex;
            flex-direction: row;
            font-weight: bold;
            border: 1px solid #e0e0e0;
            border-bottom: none;
            padding: 3px;
          "
        >
          标准套餐
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            border: 1px solid #e0e0e0;
            border-bottom: none;
          "
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            项目
          </div>
          <div style="width: 80%; padding: 3px">内容与附加权利义务介绍</div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            border: 1px solid #e0e0e0;
            border-bottom: none;
          "
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            专属流量优先
          </div>
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            内容介绍
          </div>
          <div style="width: 60%; padding: 3px">
            当最终用户概括搜索服务项目（如：“洗车、汽车美容、汽车保养、汽车维修”）时，依照最终用户地理定位优先显示其附近的“黑卡商家”列表。
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            border: 1px solid #e0e0e0;
            border-bottom: none;
          "
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            专属黑卡标记
          </div>
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            内容介绍
          </div>
          <div style="width: 60%; padding: 3px">
            “黑卡”商家在高德地图上可获得专属标志，以区分于其他商家。
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            border: 1px solid #e0e0e0;
            border-bottom: none;
          "
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            全品类支持
          </div>
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            内容介绍
          </div>
          <div style="width: 60%; padding: 3px">
            在德友惠服务端APP上除现有的“洗车”业务之外，增加多项目品类（如：汽车美容、保养、维修等）的增加，并最终同步显示在高德地图中乙方登记注册店铺的服务信息中。
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            border: 1px solid #e0e0e0;
            border-bottom: none;
          "
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            定制活动
          </div>
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            内容介绍
          </div>
          <div style="width: 60%; padding: 3px">
            “黑卡”商家可自定义店铺促销活动，如“新人减免”、“限时优惠”等自主定义内容的促销活动安排。
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            border: 1px solid #e0e0e0;
            border-bottom: none;
          "
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            24小时内客服反馈
          </div>
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            内容介绍
          </div>
          <div style="width: 60%; padding: 3px">
            对“黑卡”商家提出的问题及反馈，安排专属客服于24小时内及时应答。客服电话4006
            016 466
          </div>
        </div>
        <div
          style="display: flex; flex-direction: row; border: 1px solid #e0e0e0"
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            可选期间及价格
          </div>
          <div style="width: 80%; padding: 3px">
            一年全包价：9600元/年（根据城市有一定折扣）
          </div>
        </div>
      </div>

      <div>
        <div
          style="
            display: flex;
            flex-direction: row;
            font-weight: bold;
            border: 1px solid #e0e0e0;
            border-bottom: none;
            padding: 3px;
          "
        >
          拓展增值服务<br />“拓展增值服务”项下所列示的项目为选择性付费项目。
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            border: 1px solid #e0e0e0;
            border-bottom: none;
          "
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            雷达服务
          </div>
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            内容介绍
          </div>
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            甲方于乙方场地安装“德友惠车辆服务业工况智能监测数据系统”（雷达）用以识别乙方店铺工位是否空闲，并于在空闲时间将提醒用户该商家目前处于空闲状态，推荐用户于商家空闲时间前往接受服务。。该服务用于在“黑卡商家”工作空闲期向用户推荐指引，实现流量引导。
          </div>
          <div style="width: 40%; padding: 3px">1000元/年</div>
        </div>
        <div
          style="display: flex; flex-direction: row; border: 1px solid #e0e0e0"
        >
          <div
            style="width: 20%; border-right: 1px solid #e0e0e0; padding: 3px"
          >
            附加权利义务
          </div>
          <div style="width: 80%; padding: 10px">
            1、甲方承诺该设备系统仅用于收集门店场地操作空间占用/空闲状态数据，无视频、图像采集功能。<br />
            2、该设备只能在乙方指定的门店选择符合安全标准的位置安装。如乙方指定的安装位置不符合安全标准，则甲方有权更换安全安装位置或拒绝安装。<br />
            3、乙方明确知悉该设备的所有权归属甲方，乙方对于安装其门店的智能数据系统设备应负有以下妥善管理之义务：<br />
            （1）对已安装的智能数据设备不得擅自拆、故意损毁破坏、遮挡或阻碍其正常发挥作用；<br />
            （2）使用上的安全注意义务。依规保持设备正常使用所应有的环境状态，因未尽到安全使用义务而导致的损失应由乙方自行承担。<br />
            （3）为防止技术泄密，不得将智能数据设备转卖他人。<br />
            4、甲方所取得的数据所有权均归属于甲方。甲方对该等数据负有保密义务，不得提供与乙方有竞争关系的第三方或违反法律法规恶意使用该数据。
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class PolicyBlackcard extends Vue {}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 20px 15px;
}
</style>
